<div class="flex items-center justify-center">
  <a aria-label="Pay website" rel="home">
    <img [height]="height()" [src]="logo" [width]="width()" alt="PayNL Logo" payLibSkeletonLoader heightClass="min-h-full" widthClass="min-w-full" />
  </a>
</div>
